import { render, staticRenderFns } from "./widget8.vue?vue&type=template&id=4a20dc06&scoped=true&"
import script from "./widget8.vue?vue&type=script&lang=js&"
export * from "./widget8.vue?vue&type=script&lang=js&"
import style0 from "./widget8.vue?vue&type=style&index=0&id=4a20dc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20dc06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
